import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { getMileageLockSettingUseCase } from '../business-logic/use-cases/GetMileageLockSetting'
import { expenseRepository } from '../data-access/repositories/ExpenseRepository'

const base = ['expense']

export const expenseQueryConfig = {
  drafts: () => ({
    queryKey: buildQueryKey([...base, 'drafts']),
    queryFn: () => expenseRepository.getDrafts(),
  }),
  requestFormData: () => ({
    queryKey: buildQueryKey([...base, 'request-form-data']),
  }),
  mileageLockSetting: () => ({
    queryKey: buildQueryKey([...base, 'mileage-lock-setting']),
    queryFn: () => getMileageLockSettingUseCase.execute(),
  }),
}
